import { RootState } from '../store'
export const selectActions = (state: RootState) => state.action.relatedActions
export const selectLoading = (state: RootState) => state.action.loading
export const selectError = (state: RootState) => state.action.error
export const selectActionsWithoutProject = (state: RootState) =>
  state.action.actionsWithoutProject
